import React, { useEffect, useRef } from 'react';
import whyGelsImage from '../../assets/why-gels-image.png'; // Replace with your actual image path
import { useLocation } from 'react-router-dom';

const WhyGels = () => {

  const location = useLocation();
  const scrollRef = useRef(null);

  useEffect(() => {
    if (location.state?.scrollTo === "why-gels" && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "instant", block: "start" });
    }
  }, [location]);

  return (
    <div  ref={scrollRef} id="why-gels" className="w-full pt-12 pb-4 md:pb-12 md:py-16 md:mb-24">
      {/* Heading */}
      <div className="text-center mb-8 md:mb-16">
        <h2 className="text-2xl md:text-4xl text-[#011B5D] font-bold">Why Gels</h2>
        <div className="border-b-4 border-[#011B5D] w-24 md:w-48 mx-auto mt-2"></div>
      </div>

      {/* About Us Content */}
      <div className="max-w-7xl mx-auto flex flex-col-reverse sm:flex-row justify-evenly items-center px-6 sm:px-12 sm:space-x-8 md:space-x-32">
        
        {/* Left Side: Text and Button */}
        <div className="sm:w-3/5 mb-6 sm:mb-0 text-justify">
          <p className="text-sm sm:text-base lg:text-lg leading-6 sm:leading-normal mb-6 sm:mb-10">
            Global Exim and Logistics Solutions (GELS) have climbed up the ladder of success because of practical advice and consultancy. We have a hands-on experience of the field we are dealing in and hence are very well able to give reliable advice and consultancy services to our clients. We have a dedicated team, which takes care of the functioning of services.
            <br/><br/>Our objective is to provide the finest, most efficient, and most accurate legal documents preparation, consultancy, and legal service regarding Customs, DGFT, EEPC, and Import/Export.
          </p>
        </div>

        {/* Right Side: Image */}
        <div className="w-full sm:w-2/5 mb-6 sm:mb-0">
          <img src={whyGelsImage} alt="About Us" className="float-right w-full sm:max-h-84 rounded-lg shadow-md" />
        </div>

      </div>
    </div>
  );
};

export default WhyGels